import Main from './DomainsMain'

const Domains = {
  Main,
}

export default Domains
